import { pointItemToLngLat } from '@alltrails/maps/utils/legacyGeoJSONConversions';
import turfDistance from '@turf/distance';
import { AlgoliaHit } from 'types/Search/Algolia';
import logError from './logError';

// eslint-disable-next-line import/prefer-default-export
export function createWeightedResultList(results: AlgoliaHit[], center: [number, number], weightDistance: number) {
  const scale = weightDistance;
  const decay = 0.5;
  const magicSortFactor = -2 * (scale ** 2 / (2 * Math.log(decay)));
  const centerLngLat = [center[1], center[0]];

  return results
    .map(result => {
      const distanceToCenter = turfDistance(centerLngLat, [result._geoloc.lng, result._geoloc.lat]) * 1000;
      result.adjustedPopularity = result.popularity * Math.exp((-1 * distanceToCenter ** 2) / magicSortFactor);
      return result;
    })
    .sort((a, b) => b.adjustedPopularity - a.adjustedPopularity);
}
